import { RouteConfig } from 'vue-router'

const router: RouteConfig[] = [
  {
    path: '/messages',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: 'chats',
        component: () => import('pages/Messages/Chat.vue')
      },
      {
        path: 'general/announcements',
        component: () => import('pages/Announcements/Announcements.vue'),
        children: [
          {
            path: 'view/:id',
            component: () => import('pages/Announcements/ViewAnnouncement.vue')
          }
        ]
      },
      {
        path: 'parents/announcements/:token?',
        component: () => import('pages/Announcements/Announcements.vue'),
        children: [
          {
            path: 'view/:id',
            component: () => import('pages/Announcements/ViewAnnouncement.vue')
          }
        ],
        meta: { forParent: true }
      }
    ],
    meta: { requiresAuth: true }
  }
]

export default router
